import styled from '@emotion/styled'

export const Wrapper = styled.div`
  .ant-checkbox-wrapper {
    .ant-checkbox + span {
      padding-left: 10px;
    }
  }
`
